import type { SVGProps } from "react";
export function Close(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      data-slot="icon"
      {...props}
    >
      <clipPath id="a">
        <path d="m4 4h8v8h-8z" />
      </clipPath>
      <g
        clipPath="url(#a)"
        clipRule="evenodd"
        fill="currentColor"
        fillRule="evenodd"
      >
        <path d="m11.7986 4.20126c.1562.15621.1562.40948 0 .56569l-7.03128 7.03125c-.15621.1562-.40948.1562-.56569 0s-.15621-.4095 0-.5657l7.03127-7.03124c.1562-.15621.4095-.15621.5657 0z" />
        <path d="m4.20163 4.20126c.15621-.15621.40948-.15621.56569 0l7.03128 7.03124c.1562.1562.1562.4095 0 .5657s-.4095.1562-.5657 0l-7.03127-7.03125c-.15621-.15621-.15621-.40948 0-.56569z" />
      </g>
    </svg>
  );
}
